import { useQuery } from "@tanstack/react-query";
import { investmentOversightApi } from "../api/investmentOversight";
import { formatCurrency } from "../../../shared/utils";
import { useFilterContext } from "../../../shared/context";

export const useStates = () => {
  const { quickFilters } = useFilterContext();

  const { data, isLoading, isFetching, error, isError } = useQuery({
    queryKey: ["investment-oversight-states", quickFilters.workstream],
    queryFn: async () => {
      const params = {
        workstream_id: quickFilters.workstream || null,
      };
      const response = await investmentOversightApi.fetchStates(params);
      return response.data;
    },
  });

  return {
    data: [
      {
        label: "Total Planned Investment",
        value: formatCurrency(data?.total_planned),
        subValue: `${data?.project_count || 0} projects`,
      },
      {
        label: "Committed",
        value: formatCurrency(data?.committed),
        subValue: "Confirmed programme value",
      },
      {
        label: "Raised",
        value: formatCurrency(data?.raised),
        subValue: "Orders raised in Finance",
        // variance: '- 11.4%',
        // varianceType: 'negative',
      },
      {
        label: "Actual",
        value: formatCurrency(data?.actual),
        subValue: "Work invoiced and paid",
        // variance: '+ 47.8%',
        // varianceType: 'positive',
      },
      {
        label: "Unallocated Commitment",
        value: formatCurrency(data?.unallocated_commitment),
        subValue: "Committed - Raised",
        // variance: '+ 34.6%',
        // varianceType: 'positive',
      },
      {
        label: "Efficiency [Spend / Output]",
        value: formatCurrency(data?.efficiency) + " per site",
        subValue: "Actual - Delivered outputs",
        // variance: '+ 9.3%',
        // varianceType: 'positive',
      },
      {
        label: "Change in Scope",
        value: formatCurrency(data?.change_in_scope),
        subValue: "Approved vs baseline",
        // variance: '+ 3%',
        // varianceType: 'positive',
      },
      {
        label: "Risk Reduction",
        value: "£88M",
        subValue: "HUM - actual quantified benefits",
        // variance: '+ 15.4%',
        // varianceType: 'positive',
      },
    ],
    isLoading: isLoading || isFetching,
    error,
    isError,
  };
};
